module.exports = __webpack_public_path__ + "img/valuation.cb073ca9.jpg";